import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let resource_id = useDataValue({
    context: 'patient_image',
    path: 'id',
    viewPath: props.viewPath,
  })

  return {
    variables: { resource_id },
    pause: !resource_id,
    requestPolicy: 'network-only',
  }
}
